import React, { useEffect, useMemo, useRef, useState } from 'react'
import {
  KYSELY_COPY,
  detectKyselyLangFromHostname,
  getKyselyCookieName,
  getKyselyUrl,
  hasKyselyDismissCookie,
  normalizeKyselyLang,
  setKyselyDismissCookie,
  shouldShowKyselySurvey,
} from '../../utils/kyselySurvey.js'
import './styles.scss'

const KyselyNotification = () => {
  const lang = useMemo(() => normalizeKyselyLang(detectKyselyLangFromHostname()), [])
  const copy = KYSELY_COPY[lang]
  const cookieName = getKyselyCookieName(lang)
  const kyselyUrl = getKyselyUrl(lang)
  const dontShowAgainRef = useRef(null)

  const [visible, setVisible] = useState(false)

  useEffect(() => {
    if (!shouldShowKyselySurvey()) {
      setVisible(false)
      return
    }
    setVisible(!hasKyselyDismissCookie(cookieName))
  }, [cookieName])

  function closePopup() {
    if (dontShowAgainRef.current?.checked) {
      setKyselyDismissCookie(cookieName)
    }
    setVisible(false)
  }

  if (!visible) {
    return null
  }

  return (
    <div className="kysely-notification">
      <div className="popup">
        <button
          className="close-btn"
          onClick={closePopup}
          aria-label={copy.closeAria}
          type="button"
        >
          X
        </button>
        <h2>{copy.heading}</h2>
        <p>{copy.firstParagraph}</p>
        <p>{copy.secondParagraph}</p>
        <a href={kyselyUrl} target="_blank" rel="noreferrer noopener">
          {copy.link}
        </a>
        <div className="checkbox-container">
          <input
            ref={dontShowAgainRef}
            type="checkbox"
            id="kysely-dont-show-again"
            name="dont-show-again"
          />
          <label htmlFor="kysely-dont-show-again">{copy.dontShowAgain}</label>
        </div>
        <button type="button" onClick={closePopup}>
          {copy.close}
        </button>
      </div>
    </div>
  )
}

export default KyselyNotification
